import type { CurrentUser, EnrollmentOffer, SignInResult } from '@/types/api';
import { apiRequest } from '@/api/client';

/** Signing in and out, and the signed-in account's own settings. */
export const authApi = {
  me: () => apiRequest<CurrentUser>('/auth/me'),

  login: (credentials: { login: string; password: string; totpCode?: string }) =>
    apiRequest<SignInResult>('/auth/login', { method: 'POST', body: credentials }),

  logout: () => apiRequest<{ ok: boolean }>('/auth/logout', { method: 'POST' }),

  updateProfile: (displayName: string | null) =>
    apiRequest<{ displayName: string | null }>('/auth/me', { method: 'PATCH', body: { displayName } }),

  changePassword: (input: { currentPassword: string; newPassword: string }) =>
    apiRequest<{ revokedSessions: number }>('/auth/password', { method: 'POST', body: input }),

  /** Finishes a sign-in that stopped at binding an authenticator. */
  completeEnrollment: (input: { token: string; code: string }) =>
    apiRequest<SignInResult>('/auth/mfa/enroll', { method: 'POST', body: input }),

  startMfaSetup: () => apiRequest<EnrollmentOffer>('/auth/mfa/setup', { method: 'POST' }),

  activateMfa: (input: { token: string; code: string }) =>
    apiRequest<{ ok: boolean }>('/auth/mfa/activate', { method: 'POST', body: input }),
};
